import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bcac-button',
  templateUrl: './bcac-button.component.html',
  styleUrls: ['./bcac-button.component.scss']
})
export class BcacButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input()
  bcacContent: string = "";

  @Input()
  bcacType: string = "default";

  @Input()
  bcacShape: string;

  @Input()
  bcacSize: string = "default";

  @Input()
  disabled: boolean = false;

  @Input()
  bcacGhost: boolean = false;

  @Input()
  bcacBlock: boolean = false;

  @Input()
  bcacLoading: boolean = false;

}
